(function () {
  // The drawer and the cart page can both print this script.
  if (window.YPCartDiscountLoaded) return;
  window.YPCartDiscountLoaded = true;

  var MSG_SUCCESS = ''; // the applied-code pill replaces this message (29 Sep 2026)
  var MSG_INVALID = "That code isn't valid.";
  var MSG_ERROR = "Couldn't apply that code. Try again at checkout.";

  function routes() {
    return (window.theme && theme.routes) || {};
  }

  function getCart() {
    return fetch(routes().cart || '/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); });
  }

  // cart.discount_codes is the only reliable answer: it lists every code the
  // session has tried, each with its own `applicable` flag. Checking
  // total_discount instead gives a false pass whenever the cart already has a
  // discount (a sitewide code like flash50), and it can never confirm a
  // free-shipping code at all, because /cart.js has no shipping in it.
  function findCode(cart, code) {
    var list = cart.discount_codes || [];
    var wanted = code.toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].code).toLowerCase() === wanted) return list[i];
    }
    return null;
  }

  // A code that isn't applicable is usually blocked by one that is — Shopify
  // only stacks codes when both are set to combine. Naming the culprit is more
  // use to the shopper than "invalid".
  function blockingCode(cart, code) {
    var list = cart.discount_codes || [];
    var entered = code.toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (list[i].applicable && String(list[i].code).toLowerCase() !== entered) return list[i].code;
    }
    return null;
  }

  function CartDiscount(el) {
    this.el = el;
    this.toggle = el.querySelector('[data-discount-toggle]');
    this.panel = el.querySelector('[data-discount-panel]');
    this.input = el.querySelector('[data-discount-input]');
    this.apply = el.querySelector('[data-discount-apply]');
    this.msg = el.querySelector('[data-discount-msg]');
    this.applied = el.querySelector('[data-discount-applied]');
    this.busy = false;

    if (!this.toggle || !this.panel || !this.input || !this.apply) return;

    this.toggle.addEventListener('click', this.onToggle.bind(this));
    this.apply.addEventListener('click', this.onApply.bind(this));
    if (this.applied) this.applied.addEventListener('click', this.onRemove.bind(this));
    document.addEventListener('cart:updated', this.refresh.bind(this));
    this.refresh();

    // iPhone scrolls the page to make room for the keyboard; put it back where
    // it was once the keyboard closes, so the cart keeps filling the screen.
    this.input.addEventListener('focus', function () { this.scrollY = window.scrollY; }.bind(this));
    this.input.addEventListener('blur', function () {
      var y = this.scrollY;
      if (typeof y === 'number') setTimeout(function () { window.scrollTo(0, y); }, 60);
    }.bind(this));

    // Enter applies the code instead of submitting the cart form (which would
    // send the shopper straight to checkout).
    this.input.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Enter') return;
      evt.preventDefault();
      this.onApply();
    }.bind(this));
  }

  CartDiscount.prototype.onToggle = function () {
    var open = this.toggle.getAttribute('aria-expanded') === 'true';
    this.toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    this.el.classList.toggle('is-open', !open);
    this.panel.hidden = open;
    // No automatic focus (30 Sep 2026): focusing pops the iPhone keyboard,
    // which shoved the cart up. The keyboard now only opens when the shopper
    // taps into the box. Closing the box also clears any "Invalid" message.
    if (open) this.setMessage('');
  };

  CartDiscount.prototype.close = function () {
    this.toggle.setAttribute('aria-expanded', 'false');
    this.el.classList.remove('is-open');
    this.panel.hidden = true;
    this.setMessage('');
  };

  // Money saved by one code: its line-level allocations plus any cart-level amount.
  function codeAmount(cart, code) {
    var c = String(code).toLowerCase(), total = 0;
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && String(a.discount_application.title).toLowerCase() === c) total += a.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (String(a.title).toLowerCase() === c) total += a.total_allocated_amount;
    });
    return total;
  }

  function money(cents) {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function esc(t) {
    return String(t).replace(/[&<>"']/g, function (ch) { return '&#' + ch.charCodeAt(0) + ';'; });
  }

  // Applied codes show as a removable pill in place of the "Have a discount code?" link.
  CartDiscount.prototype.render = function (cart) {
    if (!this.applied) return;
    // Kit codes (BYOB...) are applied by the Build Your Own Kit page and show on
    // the product lines, so they get no removable tag (30 Sep 2026).
    var live = (cart.discount_codes || []).filter(function (d) { return d.applicable && !/^BYOB/i.test(d.code); });
    this.applied.innerHTML = live.map(function (d) {
      var amt = codeAmount(cart, d.code);
      return '<span class="cart-discount__pill">' + esc(String(d.code).toUpperCase()) + ' applied' +
        (amt > 0 ? ' <b>&minus;' + money(amt) + '</b>' : '') +
        '<button type="button" class="cart-discount__remove" data-discount-remove="' + esc(d.code) + '" aria-label="Remove code ' + esc(d.code) + '">&times;</button></span>';
    }).join('');
    this.applied.hidden = live.length === 0;
    this.el.classList.toggle('has-code', live.length > 0);
    this.toggle.hidden = live.length > 0;
  };

  CartDiscount.prototype.refresh = function () {
    var self = this;
    getCart().then(function (cart) { self.render(cart); }).catch(function () {});
  };

  CartDiscount.prototype.onRemove = function (evt) {
    var btn = evt.target.closest('[data-discount-remove]');
    if (!btn || this.busy) return;
    var gone = btn.getAttribute('data-discount-remove').toLowerCase();
    var self = this;
    this.setBusy(true);
    getCart().then(function (cart) {
      var keep = (cart.discount_codes || []).filter(function (d) { return d.applicable && String(d.code).toLowerCase() !== gone; }).map(function (d) { return d.code; });
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: keep.join(',') })
      });
    }).then(getCart).then(function (cart) {
      self.render(cart);
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function () {
      self.setMessage(MSG_ERROR, 'error');
    }).then(function () { self.setBusy(false); });
  };

  CartDiscount.prototype.setMessage = function (text, kind) {
    if (!this.msg) return;
    this.msg.textContent = text || '';
    this.msg.hidden = !text;
    this.msg.classList.toggle('cart-discount__msg--ok', kind === 'ok');
    this.msg.classList.toggle('cart-discount__msg--error', kind === 'error');
  };

  CartDiscount.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.apply.disabled = busy;
    this.el.classList.toggle('is-busy', busy);
  };

  CartDiscount.prototype.onApply = function () {
    if (this.busy) return;

    var code = (this.input.value || '').trim();
    if (!code) {
      this.input.focus();
      return;
    }

    var self = this;
    // Close the phone keyboard straight away so the drawer goes back to
    // filling the screen instead of sliding up with the keyboard (30 Sep 2026).
    this.input.blur();
    this.setMessage('');
    this.setBusy(true);

    // /discount/CODE applies the code to the session, then redirects. We only
    // care that the request completes; the cart tells us whether it stuck.
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .then(getCart)
      .then(function (cart) {
        var entry = findCode(cart, code);

        if (entry && entry.applicable) {
          self.setMessage('');
          self.input.value = '';
          self.close();
          self.render(cart);
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          return;
        }

        // Shopify marks an unrecognised code and a valid-but-non-combining one
        // the same way (applicable: false), so the message must cover both
        // rather than claim to know which it was.
        var blocker = blockingCode(cart, code);
        if (blocker) {
          // One line on a phone (30 Sep 2026). Shopify can't tell a mistyped
          // code from one that won't combine, so the message covers both.
          var name = String(blocker).toUpperCase();
          self.setMessage('Invalid, or can\'t combine with ' + (name.length > 10 ? 'your code' : name) + '.', 'error');
        } else {
          self.setMessage(MSG_INVALID, 'error');
        }
      })
      .catch(function () {
        self.setMessage(MSG_ERROR, 'error');
      })
      .then(function () {
        self.setBusy(false);
      });
  };

  function init() {
    document.querySelectorAll('[data-cart-discount]').forEach(function (el) {
      if (el.discountInstance) return;
      el.discountInstance = new CartDiscount(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
